<template>
  <div class="distribution_Detial55">
    
        <van-nav-bar
        v-if="!showAddress"
        :title="$t('other.a1368')"
        :left-text="$t('other.a1279')"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        />
        <van-nav-bar
        v-if="showAddress"
        :title="$t('other.a91')"
        />
       <van-address-edit
        v-if="showAddress"
        show-postal
        show-delete
        :save-button-text="$t('other.a3180')"
        :show-area="false"
        @save="onSave"
       
        />

    <van-pull-refresh class="refresh" v-if="!showAddress" v-model="isLoading" @refresh="onRefresh">
           <swiper  ref="mySwiper" >
            <swiper-slide  v-for="(item,index) in productData.images" :key="index" :options="swiperOptions">
                <div style="width:375px">
                    <img style="width:100%" :src="item.image" />
                </div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
  
       
      <div class="desc">
          <div class="price">Price：9.9</div>
          <div class="productname">{{productData.name}}</div>

          <div class="skuName" @click="show=true">
              {{$t('other.a1245')}}:
              <span class="skubox" v-for="(item,index) in productData.variations" :key="index">
                  {{item.variationSku}}
              </span>
          </div>
      </div>
      <div class="detailmore">
          {{$t('other.a1717')}}
          <div>
               <van-field
                v-model="productData.description"
                autosize
                type="textarea"
                :placeholder="$t('other.a1746')"
                />
          </div>
          <div class="pic_pb" v-for="(item,index) in productData.images" :key="index">
              <img :src="item.image" >
          </div>
      </div>


     
      
      </van-pull-refresh>

        <van-sku
        v-model="show"
        :stepper-title="$t('other.a3181')"
        :sku="sku"
        :goods="goods"
        @buy-clicked="onBuyClicked"
        @add-cart="onAddCartClicked"
        >


        <template #sku-header-price="props">
            <div class="van-sku__goods-price">
            <span class="van-sku__price-symbol"></span
            ><span class="van-sku__price-num">{{ props.price }}</span>
            </div>
        </template>
        <template #sku-actions="props">
            <div class="van-sku-actions">
     
            <van-button
                square
                size="large"
                type="danger"
                @click="props.skuEventBus.$emit('sku:buy')"
            >
                {{$t('other.a3182')}}
            </van-button>
            </div>
        </template>
        </van-sku>

      <van-goods-action v-if="!showAddress">
       
        <van-goods-action-button type="danger" @click="show=true" :text="$t('other.a3183')" />
        </van-goods-action>
      
     
  </div>
</template>

<script>
import api from '../../../../api/api'
import newOrdersApi from '../../../../api/moudles/newOrders'
import utils from '../../../../utils/utils'


export default {
data(){
return{
    showAddress:false,
    goods: {
    // 默认商品 sku 缩略图
    picture: 'https://img01.yzcdn.cn/1.jpg'
    },
    sku: {
            // 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
            // 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
            tree: [
                {
                    k: '颜色', // skuKeyName：规格类目名称
                    k_s: 's1', // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
                    v: [
                        {
                        id: '1', // skuValueId：规格值 id
                        name: '红色', // skuValueName：规格值名称
                        imgUrl: 'https://img01.yzcdn.cn/1.jpg', // 规格类目图片，只有第一个规格类目可以定义图片
                        previewImgUrl: 'https://img01.yzcdn.cn/1p.jpg', // 用于预览显示的规格类目图片
                        },
                        {
                        id: '2',
                        name: this.$t('other.a1293'),
                        imgUrl: 'https://img01.yzcdn.cn/2.jpg',
                        previewImgUrl: 'https://img01.yzcdn.cn/2p.jpg',
                        }
                    ],
                    largeImageMode: false, //  是否展示大图模式
                }
            ],

            // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
            list: [
                {
                id: 2259, // skuId
                s1: '1', // 规格类目 k_s 为 s1 的对应规格值 id
                // s2: '1', // 规格类目 k_s 为 s2 的对应规格值 id
                price: 100, // 价格（单位分）
                stock_num: 98 // 当前 sku 组合对应的库存
                },
                {
                id: 8, // skuId
                // s1: '2', // 规格类目 k_s 为 s1 的对应规格值 id
                s1: '2', // 规格类目 k_s 为 s2 的对应规格值 id
                price: 100, // 价格（单位分）
                stock_num: 10 // 当前 sku 组合对应的库存
                },
            ],
            price: '1.00', // 默认价格（单位元）
            stock_num: 227, // 商品总库存
            collection_id: 2261, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
            none_sku: false, // 是否无规格商品
          
            
    },
    show:false,
    areaList:[
    {
        code: '110000',
        name: '北京市',
    },
    {
        code: '110100',
        name: '北京市',
    },
    {
        code: '110101',
        name: '东城区',
    },
    ],
    searchResult: [],
    productData:{
        images:[]
    },
    isLoading:false,
    storeItem:{
        storeItems:[]
    },
    mainItem:{},
    userId:JSON.parse(localStorage.getItem('userInfo')).userId,
    swiperOptions: {
          pagination:  '.swiper-pagination'
        
          // Some Swiper option/callback...
        }
}
},
computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
created(){
    this.getData()
    
},
methods:{
    onChangeDetail(val) {
      if (val) {
        this.searchResult = [
          {
            name: '黄龙万科中心',
            address: '杭州市西湖区',
          },
        ];
      } else {
        this.searchResult = [];
      }
    },

    onSave(content) {
      console.log('content',content)
      console.log('maint',this.mainItem)
      let params={
          items:[{
              cusCode:this.mainItem.selectedSkuComb.s1,
              quantity:this.mainItem.selectedNum,
              tierId:this.mainItem.selectedSkuComb.id,
          }],
          msg:null,
          orderAddress:{
              country:this.country,
              district:null,
              city:null,
              fullAddress:content.addressDetail,
              zipCode:null,
              phone:content.tel,
              name:content.name,
          }

      }

      console.log('params',params)
      api
      .placeDxsOrder(params)
      .then(res => {
      if(res.code === 200 ){
      console.log('desc',res.data)
      this.$toast(this.$t('other.a3184'));
      }else{
      this.$toast(res.msg);
      }
      })
    },
    onDelete() {
      this.showAddress=false
    },

    getData(){
        let productId=this.$route.query.productId
        if(productId){
            api
            .getProductByproductId({productId:productId})
            .then(res => {
            if(res.code === 200 ){
            console.log('productId',res.data)
            this.productData=res.data
            this.goods.picture=res.data.images[0].image
            this.sku.tree=[{
                k: 'sku', // skuKeyName：规格类目名称
                k_s: 's1', // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
                v: res.data.variations.map((i,index) => {
                    return {
                        id:i.cusCode,
                        name:i.variationSku,
                        imgUrl:res.data.images[0].image,
                        previewImgUrl:res.data.images[0].image
                    }
                }),
                largeImageMode: false, //  是否展示大图模式
            }]


            this.sku.list=res.data.variations.map((p,index) => {
                return {
                    id: p.tierId, // skuId
                    s1: p.cusCode, // 规格类目 k_s 为 s2 的对应规格值 id
                    price: p.price*100, // 价格（单位分）
                    stock_num: p.stock // 当前 sku 组合对应的库存
                }
            })

            console.log(this.sku)


            }else{
            this.$message.warning(res.msg)
            }
            })

        }
    },
    getRecommond(){
        
        let str='catid='+this.storeItem.categoryData.catId+'&itemid='+this.storeItem.categoryData.itemId+'&shopid='+this.storeItem.categoryData.shopId
        
        let url=utils.getSimilaryData(this.storeItem.country.toLowerCase(),str)
        console.log('str',str)
        console.log('str',url)
        newOrdersApi
        .proxyHttps({
            type:0,
            url:url,
            headerMap:null
        })
        .then(res => {
        if(res.code === 200 ){
        console.log('desc',res.data)
        }else{
        this.$message.warning(res.msg)
        }
        })
    },

    onPointClicked(){

    },
    // 立即购买
    onBuyClicked(val){
        console.log(val)
        this.mainItem=JSON.parse(JSON.stringify(val))
        this.country=this.productData.country
        this.show=false
        this.showAddress=true
    },
    onAddCartClicked(val){
        console.log(val)
    },
    
    onSubmit(){
        console.log(this.storeItem)
        let id=this.storeItem.storeItems[0].userId
        if(id == this.userId){
             this.$dialog.alert({
            message: $t('other.a1703'),
           
            })
            return
        }

        this.storeItem.userId=this.userId
        

        api
        .copyStoreItem(this.storeItem)
        .then(res => {
          if(res.code === 200) {
            this.$dialog.alert({
            message: $t('other.a1749'),
            title:$t('other.a1708')
            });
            
          }else{
            this.$dialog.alert({
                message: res.msg,
                title:$t('other.a1709')
                });
          }
        })


    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t('other.a1228'));
        this.isLoading = false;
       
      }, 1000);
    },

    onClickLeft(){
        this.$router.push({
            path:'iddstation',
            query:{
                userId:this.$route.query.userId
            }
        })
    },
    onClickRight(){
        
    },
    

}
}

</script>
<style lang="scss" scoped>
.distribution_Detial55{
    background-color: #eee;
    margin-bottom: 40px;

    /deep/ .swiper-pagination-bullet-active{
        background-color: #409eff;
        }

    /deep/ .swiper-container{
        width: 375px;
    }  

    .pic_pb{
        width: 100%;

        img{
            width: 100%;
        }
    }

    .refresh{
        padding-top: 50px;
    }

    .detailmore{
        background-color: #fff;
        margin: 10px 0;
    }


    .desc{
        background-color: #fff;
        box-sizing: border-box;
        padding: 5px 10px;

        .price{
            color: red;
            font-size: 1rem;
            padding: 10px 0;
        }

        .productname{
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            font-size: 0.8rem;
            overflow: hidden;
            text-overflow:ellipsis;
           
        }

        .skuName{
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            font-size: 0.6rem;
            overflow: hidden;
            text-overflow:ellipsis;
            margin: 10px 0;
        }

        .skubox{
            display: inline-block;
            background-color: #eee;
            padding: 3px 8px;
            border-radius: 5px;
            line-height: 1rem;
            margin-right: 2px;
            margin-bottom: 5px;
        }
    }
    
 

    .van-nav-bar{
        background-color: #409eff;
        position: fixed;
        left: 0;
        right: 0;
        z-index: 99999;
    }


    /deep/ .van-address-edit{
        height: 100vh;
        box-sizing: border-box;
        padding-top:60px;
        
    }

    /deep/ .van-nav-bar__text {
        color: #fff !important;
        font-size: 18px;
    }

    /deep/ .van-icon{
        color: #fff;
    }

    /deep/ .van-nav-bar__title{
        color:#fff
    }
    
    /deep/ .van-submit-bar{
        border-top: 0.1rem solid #eee;
        background-color: #eee;
    }
    
}


</style>